var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ApiService } from '../../../service/api.service';
import { Select2ajaxService } from './select2ajax.service';
import { RequestQuery } from '../../../component/list/list.service';
import { Option } from '../../../models/option/option';
import { ColumnBaseService } from '../base/columnbase.service';
var Select2AjaxComponent = /** @class */ (function (_super) {
    __extends(Select2AjaxComponent, _super);
    function Select2AjaxComponent(service, baseService, apiService, s2Service) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.apiService = apiService;
        _this.s2Service = s2Service;
        _this.option = new Option();
        return _this;
    }
    Select2AjaxComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.col.readonly) {
            this.option = this.s2Service.getOption(this.componentName, this.baseService.getColKey(this.componentName, this.col.key, this.index));
        }
    };
    Select2AjaxComponent.prototype.ngAfterViewInit = function () {
        if (!this.col.readonly) {
            this.element = this.select2Element.nativeElement;
            this.setSelect2();
            this.setSelect2Event();
        }
    };
    Select2AjaxComponent.prototype.setSelect2 = function () {
        var _this = this;
        var url = this.apiService.makeUrl(this.s2Service.getUrl());
        var params = this.col.params || {};
        var width = params.formClass && params.formClass.width ? '100%' : '200px';
        var placeholder = params.placeholder || '';
        var query = params.query || new RequestQuery();
        var data = [];
        var option = this.s2Service.getOption(this.componentName, this.baseService.getColKey(this.componentName, this.col.key, this.index));
        if (option && option.code && option.display) {
            data = [{ id: option.code, text: option.display }];
        }
        var self = this;
        $(this.element).select2({
            data: data,
            placeholder: placeholder,
            allowClear: !this.col.required,
            width: width,
            ajax: {
                delay: 300,
                dataType: 'json',
                url: url,
                xhrFields: { withCredentials: true },
                data: function (params) {
                    var q = Object.assign(new RequestQuery(), {
                        limit: 10,
                        offset: params.page ? (params.page - 1) * 10 : 0
                    });
                    if (params.term && typeof query.predicateList !== 'undefined') {
                        var queryStr = JSON.stringify(query.predicateList);
                        queryStr = queryStr.replace(/:term/g, params.term);
                        q.predicateList = JSOG.parse(queryStr);
                    }
                    return {
                        name: _this.col.dataType,
                        query: JSON.stringify(q),
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    var options = [];
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var option_1 = data_1[_i];
                        options.push({
                            id: option_1.code,
                            text: option_1.display
                        });
                    }
                    params.page = params.page || 1;
                    return {
                        results: options,
                        pagination: {
                            more: options.length === 10
                        }
                    };
                },
                transport: function (params, success, failure) {
                    var $success = function (data, textStatus, jqXHR) {
                        self.apiService.checkBuildNoStr(jqXHR.getResponseHeader('x-pg-spa-buildno'));
                        success(data);
                    };
                    var $failure = function (jqXHR) {
                        var checkBuildNo = self.apiService.checkBuildNoStr(jqXHR.getResponseHeader('x-pg-spa-buildno'));
                        if (checkBuildNo && jqXHR.status === 401) {
                            $(self.element).select2('close');
                            self.apiService.onUnauthorized(jqXHR.responseJSON);
                        }
                        failure();
                    };
                    var $request = $.ajax(params);
                    $request.then($success);
                    $request.fail($failure);
                    return $request;
                }
            }
        });
    };
    Select2AjaxComponent.prototype.setSelect2Event = function () {
        var self = this;
        $(this.element).on('select2:select', function (e) {
            self.onChange({ code: e['params']['data']['id'], display: e['params']['data']['text'] });
        });
        $(this.element).on('select2:unselect', function (e) {
            self.onChange({ code: '', display: '' });
        });
    };
    Select2AjaxComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (this.val && typeof this.val.code !== 'undefined' && typeof this.val.display !== 'undefined') {
            this.setOption(this.val);
        }
        if (changes.val && !changes.val.firstChange && !this.col.readonly) {
            if (this.val && typeof this.val.code !== 'undefined') {
                this.setSelect2();
                $(this.element).val(this.val.code).trigger('change');
                this.onChange(this.val, false);
            }
            else {
                $(this.element).val(this.val).trigger('change');
            }
        }
    };
    Select2AjaxComponent.prototype.onChange = function (e, changeFlg) {
        if (changeFlg === void 0) { changeFlg = true; }
        this.setOption({ code: e.code, display: e.display });
        _super.prototype.onChange.call(this, e.code, changeFlg);
    };
    Select2AjaxComponent.prototype.setOption = function (val) {
        this.s2Service.setOption(this.componentName, this.baseService.getColKey(this.componentName, this.col.key, this.index), val);
        this.option = val;
    };
    Select2AjaxComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-select2ajax',
                    template: '<select *ngIf="!col.readonly" name="{{ colKey }}" attr.name="{{ colKey }}" [(ngModel)]="val" [key]="key" [col]="col" columnDir #s2></select>'
                        + '<column-formreadonly *ngIf="col.readonly" [componentName]="componentName" [index]="index" [col]="col" [val]="option" [msg]="msg"></column-formreadonly>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    Select2AjaxComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ApiService },
        { type: Select2ajaxService }
    ]; };
    Select2AjaxComponent.propDecorators = {
        select2Element: [{ type: ViewChild, args: ['s2',] }]
    };
    return Select2AjaxComponent;
}(ColumnBaseComponent));
export { Select2AjaxComponent };
//# sourceMappingURL=select2ajax.component.js.map